import { observable, computed, action, makeObservable } from 'mobx'
import Collection from '../Collections/Collection'
import AllocationAggregateModel from './AllocationAggregateModel'
import Aggregate from './Aggregate'
import bind from 'bind-decorator'
import tuple from 'immutable-tuple'

class AllocationAggregate extends Aggregate {
    constructor() {
        super({ collectionClass: AllocationAggregateCollection })
        makeObservable(this)
    }
}

class AllocationAggregateCollection extends Collection {
    constructor() {
        super({
            collection: 'allocations',
            modelClass: AllocationAggregateModel,
        })
        this.addLookup('allocationsByProjectId', 'manyByKey', {
            key: (t) => t.projectId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('allocationsByPhaseId', 'manyByKey', {
            key: (t) => t.phaseId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('allocationsByStaffId', 'manyByKey', {
            key: (t) => t.staffId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('allocationsByRoleId', 'manyByKey', {
            key: (t) => t.roleId || t.staff?.roleId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('allocationsByMonth', 'manyByKey', {
            key: (t) => t.month,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('allocationsByModelTuple', 'manyByMany', {
            keys: (t) => [
                tuple(t.project?.id, undefined, undefined, undefined),
                tuple(undefined, t.phase?.id, undefined, undefined),
                tuple(undefined, undefined, t.role?.id, undefined),
                tuple(undefined, undefined, undefined, t.staff?.id),

                tuple(t.project?.id, t.phase?.id, undefined, undefined),
                tuple(t.project?.id, undefined, t.role?.id, undefined),
                tuple(t.project?.id, undefined, undefined, t.staff?.id),
                tuple(undefined, t.phase?.id, t.role?.id, undefined),
                tuple(undefined, t.phase?.id, undefined, t.staff?.id),
                tuple(undefined, undefined, t.role?.id, t.staff?.id),

                tuple(t.project?.id, t.phase?.id, t.role?.id, undefined),
                tuple(t.project?.id, t.phase?.id, undefined, t.staff?.id),
                tuple(t.project?.id, undefined, t.role?.id, t.staff?.id),
                tuple(undefined, t.phase?.id, t.role?.id, t.staff?.id),

                tuple(t.project?.id, t.phase?.id, t.role?.id, t.staff?.id),
            ],
            filter: (t) => !t.deletedAt,
        })
        makeObservable(this)
    }
    get allocationsById() {
        return this.modelsById
    }
    get allocations() {
        return this.models
    }
    get allocationsById() {
        return this.modelsById
    }
    @action.bound
    addAllocation(data) {
        this.add(data)
    }
    @action.bound
    addAllocations(data) {
        this.addMany(data)
    }
}

export default new AllocationAggregate()
export const AllocationAggregateCollectionClass = AllocationAggregateCollection
